// Copyright (c) Bentley Systems
export type HeaderButtonInterface = {
  label: string | undefined;
  generateLeftShade: boolean;
};

const TableHeaderCellItemAction = (props: HeaderButtonInterface) => {
  return (
    <div>
      <span>{props.label}</span>
      {props.generateLeftShade && (
        <div className="becs-table-cell-shadow-left-elist" />
      )}
    </div>
  );
};

export default TableHeaderCellItemAction;
